import React, { useCallback, useEffect, useState } from 'react';

import { useStyles } from './style';
import { Alert } from '@material-ui/lab';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router';
import { IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import cardImg from '../../../../../assets/images/card.png';
import { useGetUserPaymentMethodsQuery, useMeQuery } from '../../../../../api/user';
import { RestaurantUser } from '../../../../../api/user/types';

interface Props {
  onBtnClick: () => void;
}

export const AddPaymentBanner: React.FC<Props> = ({ onBtnClick }) => {
  const { push } = useHistory();
  const classes = useStyles();
  // const [showBanner, setShowBanner] = useState(false);

  // const { data: user } = useMeQuery();
  // const { data: paymentMethods, isFetching } = useGetUserPaymentMethodsQuery((user as RestaurantUser)?.stripe_id as string, { skip: !(user as RestaurantUser)?.stripe_id });

  // const removeThisBanner = useCallback(() => {
  //   setShowBanner(false);
  // }, []);

  // useEffect(() => {
  //   if(!isFetching && !user?.is_supplier) {
  //     setShowBanner(!paymentMethods?.default_method);
  //   }
  // }, [user, paymentMethods, isFetching]);

  return (
    <Alert
      classes={{ root: classes.root }}
      icon={<img src={cardImg} height={38} />}
      severity="info"
      action={
        <>
          <Button variant="contained" className={classes.upgradeButton} onClick={onBtnClick}>
            Add Payment Method
          </Button>
        </>
      }
    >
      <Typography variant="subtitle1" component="div" className={classes.title}>
        Pay by card. Keep your cash in hand.
      </Typography>
      <Typography variant="body2" component="div" className={classes.description}>
        Start earning rewards today.
      </Typography>
    </Alert>
  );
};
